import * as React from 'react';
import Form from 'src/components/controls/forms/Form';
import { AnyObject, FormApi } from 'final-form';
import PropertyUtil from 'src/util/PropertyUtil';
import TractDetailData from 'src/models/tract_detail/TractDetail';
import SearchResult from 'src/models/OwnerSearchResult';
import AddOwnershipPages from './AddOwnershipPages';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import * as _ from 'lodash';
import OwnerTracts from 'src/components/project/sections/owners/OwnerTracts';
import Button from 'src/components/controls/forms/redesign/FormButton';
import FormCheckbox from 'src/components/controls/forms/redesign/FormCheckbox';
import FormLabel from 'src/components/controls/forms/FormLabel';
import IOwner from 'src/models/IOwner';
import OwnerIndividual from 'src/models/tract_detail/add_ownership_revised/OwnerIndividual';
import OwnerTrust from 'src/models/tract_detail/add_ownership_revised/OwnerTrust';
import AddressUtil from 'src/util/Address';
import OwnerBusiness from 'src/models/tract_detail/add_ownership_revised/OwnerBusiness';
import OwnerRAL from 'src/models/tract_detail/add_ownership_revised/OwnerRAL';
import OwnerStateLand from 'src/models/tract_detail/add_ownership_revised/OwnerStateLand';
import OwnerBOLM from 'src/models/tract_detail/add_ownership_revised/OwnerBOLM';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';
import { SelectItem } from 'src/models/common/SelectItem';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import FormToggle from 'src/components/controls/forms/redesign/FormToggle';
import PhoneNumberType from 'src/models/PhoneNumberType';
import AddOwner from 'src/models/tract_detail/add_ownership_revised/AddOwner';
import { FormErrors } from 'src/util/FormErrors';
import OwnerTypesForms from './OwnerTypesForms';
import OwnerType from './OwnerType';
import OwnerJointTenant from 'src/models/tract_detail/add_ownership_revised/OwnerJointTenant';
import LeaseGenerationTractDetail from 'src/models/leasing/LeaseGenerationTractDetail';
// import ITract from 'src/models/ITract';
// import SurfaceTract from 'src/models/SurfaceTract';

export interface IExistingOwnerFormProps {
    searchOwners: (searchText: string, ownerType: string) => void;
    turnPage: (page: AddOwnershipPages) => void;
    getTractsByOwnerId: (ownerId: number) => void;
    getOwnerDetail?: (ownerLookupId: number, containerId: number, type: string) => void;
    addDeviation?: (values: AddOwner, containerOwnerId: number, ownerType: string) => void;
    getCityState: (zipCode: number) => void;
    submitOwnership: (values: AnyObject) => void;
    validate: (values: AnyObject) => FormErrors<AnyObject>;
}

export type IExistingOwnerFormStateProps = {
    ownerTypes: { id: number; name: string }[];
    tract: TractDetailData;
    horizon: number;
    parentOwnershipId?: number;
    searchResults: PagedResultSet<SearchResult>;
    page: AddOwnershipPages;
    ownerTracts?: Array<LeaseGenerationTractDetail>;
    clientNumber: number;
    projectNumber: number;
    ownerDetails: Array<IOwner>;
    states: PagedResultSet<State>;
    phoneNumberTypes: Array<PhoneNumberType>;
    dialogType: string;
    isLeasehold?: boolean;
    getScrollStatus?: (divElement: HTMLDivElement) => void;
};

type ExistingOwnerFormState = {
    searchOwnerType: string;
    searchString: string;
    existingOwner: boolean;
    selectedOwnerIndex: number;
    selectedOwnerType: number;
    isCommunityProperty: boolean;
};

type IExistingOwnerFormPageProps = IExistingOwnerFormProps & IExistingOwnerFormStateProps;

class ExistingOwnerForm extends React.Component<IExistingOwnerFormPageProps, ExistingOwnerFormState> {
    constructor(props: IExistingOwnerFormPageProps) {
        super(props);

        this.state = {
            searchOwnerType: undefined,
            searchString: '',
            selectedOwnerType: undefined,
            existingOwner: false,
            selectedOwnerIndex: 0,
            isCommunityProperty: true,
        };
    }

    private form: FormApi;
    private ownershipPref: string = this.props.isLeasehold ? 'ownership' : 'contractOwnership';

    getTractsByOwnerId = (p: SearchResult, index: number) => {
        this.selectOwner(index);
        this.props.getTractsByOwnerId(p.id);
    };

    selectOwner = (index: number) => {
        const owners = this.props?.searchResults?.items;
        if (!owners) {
            return;
        }
        let selectedOwner = owners[0];
        for (let i = 0; i < owners.length; ++i) {
            const tempOwner = owners[i];
            if (tempOwner === undefined) {
                continue;
            }
            if (i !== index) {
                tempOwner.selected = false;
            } else {
                selectedOwner = tempOwner;
                tempOwner.selected = tempOwner.selected ? false : true;
            }
            this.form.mutators.update('owners', i, tempOwner);
        }
        const selectedOwnerType = OwnerType[selectedOwner?.type];
        this.setState({
            selectedOwnerType: selectedOwnerType
        });
        this.changeOwnerType(selectedOwnerType);
        // this.setState(this.state);
    };

    searchUpdate = _.debounce((searchText: string, ownerType: string) => {
        console.log(searchText, ownerType);
        this.setState({ searchString: searchText });
        this.props.searchOwners(searchText, ownerType);
    }, 300);
    resultsList = () => {
        if (this.state?.searchString !== undefined) {
            if (PropertyUtil.SafeGet(() => this?.props?.searchResults?.items?.length > 0)) {
                return this.props?.searchResults && this.props?.searchResults?.items?.map((owner, index) => {
                    return (
                        <div className="dialog-card-list" key={index} onClick={() => this.getTractsByOwnerId(owner, index)}>
                            <span className="lh-tenth-width">
                                <FormCheckbox label="" onChange={() => this.selectOwner(index)} name={`owners[${index}].selected`} />
                            </span>
                            <span className="lh-fourth-width">{`${owner.id}`}</span>
                            <span className="lh-fourth-width">{`${owner.name}`}</span>
                            <span className="lh-fourth-width">{`${owner.type}`}</span>
                        </div>
                    );
                });
            } else {
                return <div>No Owners Were Found</div>;
            }
        } else {
            return <div style={{ textAlign: 'center' }}>Enter a ID, First or Last Name to Search for Existing Owners</div>;
        }
    };

    changeOwnerType = (ownerType: string) => {
        switch (ownerType) {
            case 'Individual':
                this.form.change('ownerType', '0');
                break;

            case 'Trust':
                this.form.change('ownerType', '1');
                break;

            case 'Business':
                this.form.change('ownerType', '2');
                break;

            case 'Gov-BLM':
                this.form.change('ownerType', '3');
                break;

            case 'Gov-RAL':
                this.form.change('ownerType', '4');
                break;

            case 'Gov-STATE':
                this.form.change('ownerType', '5');
                break;

            case 'JointTenant':
                this.form.change('ownerType', '6');
                break;

            case 'BOIA':
                this.form.change('ownerType', '7');
                break;

            default:
                break;
        }
    };

    attachOwner = () => {
        const p: SearchResult = (this.form?.getState().values as AnyObject)?.owners?.find((x: SearchResult) => x.selected);
        this.props.getOwnerDetail(p.id, p.containerOwnerId, p.type);
        this.changeOwnerType(p.type);

        this.form.change('ownerLookUpId', p.id);

        this.setState({
            existingOwner: true,
        });
        this.props.turnPage(AddOwnershipPages.DeviationDecimalInterest);
    };
    selectDeviation = (index: number, ownerLookUpId: number) => {
        this.changeSelectedOwnerIndex(index, ownerLookUpId);
        this.props.turnPage(AddOwnershipPages.DeviationDecimalInterest);
    };
    changeSelectedOwnerIndex = (index: number, ownerLookUpId: number) => {
        this.setState({
            selectedOwnerIndex: index,
        });
        this.form.change('ownerLookUpId', ownerLookUpId);
    };
    onChangeCommunityPropertyToggle = (value: string) => {
        this.setState({isCommunityProperty: value === 'Yes' ? false : true});
    };

    ownerDeviations = () => {
        return this.props.ownerDetails.map((o, index) => {
            switch (o.ownerType) {
                case 'Individual':
                    const ownerIndividual = o as OwnerIndividual;
                    return (
                        <div key={index} onClick={() => this.selectDeviation(index, ownerIndividual.ownerLookUpId)}>
                            <div className="change-owner-detail-card">
                                <div className="change-owner-detail-card-name"> {ownerIndividual.firstName + ' ' + ownerIndividual.lastName} </div>
                                <div className="change-owner-detail-card-address"> {ownerIndividual.address?.addressLine1} </div>
                                <div className="change-owner-detail-card-address">
                                    {AddressUtil.concatWithCommas(
                                        ownerIndividual.address?.city,
                                        ownerIndividual.address?.state?.name,
                                        ownerIndividual.address?.zipCode
                                    )}
                                </div>
                            </div>
                        </div>
                    );

                case 'Trust':
                    const ownerTrust = o as OwnerTrust;
                    return (
                        <div key={index} onClick={() => this.selectDeviation(index, ownerTrust.ownerLookUpId)}>
                            <div className="change-owner-detail-card">
                                <div className="change-owner-detail-card-name"> {ownerTrust.trustName} </div>
                                <div className="change-owner-detail-card-address"> {ownerTrust.address?.addressLine1} </div>
                                <div className="change-owner-detail-card-address">
                                    {AddressUtil.concatWithCommas(
                                        ownerTrust.address?.city,
                                        ownerTrust.address?.state?.name,
                                        ownerTrust.address?.zipCode
                                    )}
                                </div>
                            </div>
                        </div>
                    );

                case 'Business':
                    const ownerBusiness = o as OwnerBusiness;
                    return (
                        <div key={index} onClick={() => this.selectDeviation(index, ownerBusiness.ownerLookUpId)}>
                            <div className="change-owner-detail-card">
                                <div className="change-owner-detail-card-name"> {ownerBusiness.name} </div>
                                <div className="change-owner-detail-card-address"> {ownerBusiness.address?.addressLine1} </div>
                                <div className="change-owner-detail-card-address">
                                    {AddressUtil.concatWithCommas(
                                        ownerBusiness.address?.city,
                                        ownerBusiness.address?.state?.name,
                                        ownerBusiness.address?.zipCode
                                    )}
                                </div>
                            </div>
                        </div>
                    );

                case 'Gov-RAL':
                    const ownerRAL = o as OwnerRAL;
                    return (
                        <div key={index} onClick={() => this.selectDeviation(index, ownerRAL.ownerLookUpId)}>
                            <div className="change-owner-detail-card">
                                <div className="change-owner-detail-card-name">
                                    {' '}
                                    {ownerRAL.surfaceOwnerAgentFirstName + ' ' + ownerRAL.surfaceOwnerAgentLastName}{' '}
                                </div>
                                <div className="change-owner-detail-card-address"> {ownerRAL.address?.addressLine1} </div>
                                <div className="change-owner-detail-card-address">
                                    {AddressUtil.concatWithCommas(ownerRAL.address?.city, ownerRAL.address?.state?.name, ownerRAL.address?.zipCode)}
                                </div>
                            </div>
                        </div>
                    );
                case 'Gov-STATE':
                    const ownerSL = o as OwnerStateLand;
                    return (
                        <div key={index} onClick={() => this.selectDeviation(index, ownerSL.ownerLookUpId)}>
                            <div className="change-owner-detail-card">
                                <div className="change-owner-detail-card-name"> {ownerSL.agencyName} </div>
                                <div className="change-owner-detail-card-address"> {ownerSL.address?.addressLine1} </div>
                                <div className="change-owner-detail-card-address">
                                    {AddressUtil.concatWithCommas(ownerSL.address?.city, ownerSL.address?.state?.name, ownerSL.address?.zipCode)}
                                </div>
                            </div>
                        </div>
                    );
                case 'Gov-BLM':
                    const ownerBOLM = o as OwnerBOLM;
                    return (
                        <div key={index} onClick={() => this.selectDeviation(index, ownerBOLM.ownerLookUpId)}>
                            <div className="change-owner-detail-card">
                                <div className="change-owner-detail-card-name"> {ownerBOLM.regionalOffice} </div>
                                <div className="change-owner-detail-card-address"> {ownerBOLM.address?.addressLine1} </div>
                                <div className="change-owner-detail-card-address">
                                    {AddressUtil.concatWithCommas(
                                        ownerBOLM.address?.city,
                                        ownerBOLM.address?.state?.name,
                                        ownerBOLM.address?.zipCode
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                case 'JointTenant':
                    const ownerJointTenant = o as OwnerJointTenant;
                    // TODO: Select deviation will not work for this, since it connects to multiple owners.
                    return (
                        <div key={index}>
                            <div className="change-owner-detail-card">
                                <div className="change-owner-detail-card-name"> {ownerJointTenant.name} </div>
                                <div className="change-owner-detail-card-address"> {ownerJointTenant.addressLine1} </div>
                                <div className="change-owner-detail-card-address">
                                    {AddressUtil.concatWithCommas(
                                        ownerJointTenant.city,
                                        ownerJointTenant.state,
                                        ownerJointTenant.zipCode
                                    )}
                                </div>
                            </div>
                        </div>
                    );

                default:
                    return undefined;
            }
        });
    };
    onClickCreateNewDeviation = () => {
        const selectedOwner = this.props.ownerTypes.find(
            (x) => x.name === PropertyUtil.SafeGet(() => this.props.ownerDetails[this.state.selectedOwnerIndex].ownerType)
        );
        this.changeOwnerType(selectedOwner?.name);
        this.setState({
            selectedOwnerType: selectedOwner?.id,
        });
        this.props.turnPage(AddOwnershipPages.NewDeviationInfoForm);
    };

    addNewDeviationHeader = () => {
        return (
            <>
                {PropertyUtil.SafeGet(() => this.state.selectedOwnerType) === 0 && (
                    <>
                        <div>
                            <h3>Add Individual Owner Deviation</h3>
                        </div>
                    </>
                )}
                {PropertyUtil.SafeGet(() => this.state.selectedOwnerType) === 1 && (
                    <>
                        <div>
                            <h3>Add Individual Trust Deviation</h3>
                        </div>
                    </>
                )}
                {PropertyUtil.SafeGet(() => this.state.selectedOwnerType) === 2 && (
                    <>
                        <div>
                            <h3>Add Individual Business Deviation</h3>
                        </div>
                    </>
                )}
                {PropertyUtil.SafeGet(() => this.state.selectedOwnerType) === 3 && (
                    <>
                        <div>
                            <h3>Add Gov-BLM Owner Deviation</h3>
                        </div>
                    </>
                )}
                {PropertyUtil.SafeGet(() => this.state.selectedOwnerType) === 4 && (
                    <>
                        <div>
                            <h3>Add Gov-RAL Owner Deviation</h3>
                        </div>
                    </>
                )}
                {PropertyUtil.SafeGet(() => this.state.selectedOwnerType) === 5 && (
                    <>
                        <div>
                            <h3>Add Gov-State Owner Deviation</h3>
                        </div>
                    </>
                )}
                {PropertyUtil.SafeGet(() => this.state.selectedOwnerType) === 6 && (
                    <>
                        <div>
                            <h3>Add Joint Tenant Owner Deviation</h3>
                        </div>
                    </>
                )}
            </>
        );
    };

    submitNewDevation = () => {
        const values = this.form.getState().values as AddOwner;
        let ownerTypeString;
        let containerOwnerId;
        if (values.ownerType) {
            values.ownerType = parseInt(values.ownerType + '', 10);
            ownerTypeString = this.props.ownerTypes.find((x) => x.id === values.ownerType).name;
            switch (values.ownerType) {
                case 0:
                    containerOwnerId = (this.props.ownerDetails[this.state.selectedOwnerIndex] as OwnerIndividual)?.containerOwnerId;
                    values.individualOwner.containerOwnerId = containerOwnerId;
                    values.individualOwner.ownerType = ownerTypeString;
                    break;
                case 1:
                    containerOwnerId = (this.props.ownerDetails[this.state.selectedOwnerIndex] as OwnerTrust)?.containerOwnerId;
                    values.ownerTrust.containerOwnerId = containerOwnerId;
                    values.ownerTrust.ownerType = ownerTypeString;
                    break;
                case 2:
                    containerOwnerId = (this.props.ownerDetails[this.state.selectedOwnerIndex] as OwnerBusiness)?.containerOwnerId;
                    values.businessOwner.containerOwnerId = containerOwnerId;
                    values.businessOwner.ownerType = ownerTypeString;
                    break;
                case 3:
                    containerOwnerId = (this.props.ownerDetails[this.state.selectedOwnerIndex] as OwnerBOLM)?.containerOwnerId;
                    values.bolmOwner.containerOwnerId = containerOwnerId;
                    values.bolmOwner.ownerType = ownerTypeString;
                    break;
                case 4:
                    containerOwnerId = (this.props.ownerDetails[this.state.selectedOwnerIndex] as OwnerRAL)?.containerOwnerId;
                    values.ralOwner.containerOwnerId = containerOwnerId;
                    values.ralOwner.ownerType = ownerTypeString;
                    break;
                case 5:
                    containerOwnerId = (this.props.ownerDetails[this.state.selectedOwnerIndex] as OwnerStateLand)?.containerOwnerId;
                    values.stateLandOwner.containerOwnerId = containerOwnerId;
                    values.stateLandOwner.ownerType = ownerTypeString;
                    break;
                default:
                    break;
            }
        }

        this.props.addDeviation(values, containerOwnerId, ownerTypeString);
    };

    validateAttachOwnerPopupAndNextPage = () => {
        console.log('validateAttachOwnerPopupAndNextPage');
        const formState = this.form.getState();

        if (this.props.page === AddOwnershipPages.NewOwnerDecimalInterest) {
            if (
                (formState.hasValidationErrors && formState.errors.ownership?.decimalInterest) ||
                formState.errors.ownership?.additionalOwnershipTypeId
            ) {
                console.log('form erros', formState);
                window.alert('Please Fill Out All Required Fields To Continue');
            } else {
                this.props.submitOwnership(this.form.getState().values);
            }
        }
        // tslint:disable-next-line: max-line-length
        if (
            formState.hasValidationErrors &&
            (formState.errors.individualOwner ||
                formState.errors.ownerTrust ||
                formState.errors.businessOwner ||
                formState.errors.bolmOwner ||
                formState.errors.ralOwner ||
                formState.errors.stateLandOwner)
        ) {
            window.alert('Please Fill Out All Required Fields To Continue');
        } else if (this.props.page === AddOwnershipPages.NewDeviationInfoForm) {
            this.submitNewDevation();
            this.props.turnPage(AddOwnershipPages.OwnerDeviationsPage);
        }
    };

    selectedOwnerInfo = () => {
        switch (PropertyUtil.SafeGet(() => this.props.ownerDetails[this.state.selectedOwnerIndex].ownerType)) {
            case 'Individual':
                const ownerIndividual = this.props.ownerDetails[this.state.selectedOwnerIndex] as OwnerIndividual;
                const address = ownerIndividual.address;

                return (
                    <div className="owner-detail-card">
                        <div>
                            <div className="owner-detail-card-name">{ownerIndividual.firstName + ' ' + ownerIndividual.lastName}</div>
                            {address && (
                                <>
                                    <div className="owner-detail-card-address"> {address.addressLine1} </div>
                                    <div className="owner-detail-card-address">
                                        {' '}
                                        {address.city + ', ' + address.state?.name + ', ' + address.zipCode}{' '}
                                    </div>
                                </>
                            )}
                        </div>
                        <div>
                            <Button
                                text="CHANGE OWNER INFO"
                                size="small"
                                onClick={() => this.props.turnPage(AddOwnershipPages.OwnerDeviationsPage)}
                            />
                        </div>
                    </div>
                );
            case 'Trust':
                const ownerTrust = this.props.ownerDetails[this.state.selectedOwnerIndex] as OwnerTrust;
                const trustAddress = ownerTrust.address;

                return (
                    <div className="owner-detail-card">
                        <div>
                            <div className="owner-detail-card-name"> {ownerTrust.trustName} </div>
                            {trustAddress && (
                                <>
                                    <div className="owner-detail-card-address"> {trustAddress.addressLine1} </div>
                                    <div className="owner-detail-card-address">
                                        {' '}
                                        {AddressUtil.concatWithCommas(trustAddress.city, trustAddress.state?.name, trustAddress.zipCode)}{' '}
                                    </div>
                                </>
                            )}
                        </div>
                        <div>
                            <Button
                                text="CHANGE OWNER INFO"
                                size="small"
                                onClick={() => this.props.turnPage(AddOwnershipPages.OwnerDeviationsPage)}
                            />
                        </div>
                    </div>
                );

            case 'Business':
                const ownerBusiness = this.props.ownerDetails[this.state.selectedOwnerIndex] as OwnerBusiness;
                const businessAddress = ownerBusiness.address;

                return (
                    <div className="owner-detail-card">
                        <div>
                            <div className="owner-detail-card-name"> {ownerBusiness.name} </div>
                            {businessAddress && (
                                <>
                                    <div className="owner-detail-card-address"> {businessAddress.addressLine1} </div>
                                    <div className="owner-detail-card-address">
                                        {' '}
                                        {AddressUtil.concatWithCommas(
                                            businessAddress.city,
                                            businessAddress.state?.name,
                                            businessAddress.zipCode
                                        )}{' '}
                                    </div>
                                </>
                            )}
                        </div>
                        <div>
                            <Button
                                text="CHANGE OWNER INFO"
                                size="small"
                                onClick={() => this.props.turnPage(AddOwnershipPages.OwnerDeviationsPage)}
                            />
                        </div>
                    </div>
                );

            case 'Gov-BLM':
                const ownerBOLM = this.props.ownerDetails[this.state.selectedOwnerIndex] as OwnerBOLM;
                const bolmAddress = ownerBOLM.address;

                return (
                    <div className="owner-detail-card">
                        <div>
                            <div className="owner-detail-card-name"> {ownerBOLM.regionalOffice} </div>
                            {bolmAddress && (
                                <>
                                    <div className="owner-detail-card-address"> {bolmAddress.addressLine1} </div>
                                    <div className="owner-detail-card-address">
                                        {' '}
                                        {AddressUtil.concatWithCommas(bolmAddress.city, bolmAddress.state?.name, bolmAddress.zipCode)}{' '}
                                    </div>
                                </>
                            )}
                        </div>
                        <div>
                            <Button
                                text="CHANGE OWNER INFO"
                                size="small"
                                onClick={() => this.props.turnPage(AddOwnershipPages.OwnerDeviationsPage)}
                            />
                        </div>
                    </div>
                );

            case 'Gov-RAL':
                const ownerRAL = this.props.ownerDetails[this.state.selectedOwnerIndex] as OwnerRAL;
                const ralAddress = ownerRAL.address;

                return (
                    <div className="owner-detail-card">
                        <div>
                            <div className="owner-detail-card-name">
                                {' '}
                                {ownerRAL.surfaceOwnerAgentFirstName + ' ' + ownerRAL.surfaceOwnerAgentLastName}{' '}
                            </div>
                            {ralAddress && (
                                <>
                                    <div className="owner-detail-card-address"> {ralAddress.addressLine1} </div>
                                    <div className="owner-detail-card-address">
                                        {' '}
                                        {AddressUtil.concatWithCommas(ralAddress.city, ralAddress.state?.name, ralAddress.zipCode)}{' '}
                                    </div>
                                </>
                            )}
                        </div>
                        <div>
                            <Button
                                text="CHANGE OWNER INFO"
                                size="small"
                                onClick={() => this.props.turnPage(AddOwnershipPages.OwnerDeviationsPage)}
                            />
                        </div>
                    </div>
                );

            case 'Gov-STATE':
                const ownerSL = this.props.ownerDetails[this.state.selectedOwnerIndex] as OwnerStateLand;
                const slAddress = ownerSL.address;

                return (
                    <div className="owner-detail-card">
                        <div>
                            <div className="owner-detail-card-name"> {ownerSL.agencyName} </div>
                            {slAddress && (
                                <>
                                    <div className="owner-detail-card-address"> {slAddress.addressLine1} </div>
                                    <div className="owner-detail-card-address">
                                        {' '}
                                        {AddressUtil.concatWithCommas(slAddress.city, slAddress.state?.name, slAddress.zipCode)}{' '}
                                    </div>
                                </>
                            )}
                        </div>
                        <div>
                            <Button
                                text="CHANGE OWNER INFO"
                                size="small"
                                onClick={() => this.props.turnPage(AddOwnershipPages.OwnerDeviationsPage)}
                            />
                        </div>
                    </div>
                );

            case 'Joint Tenant':
                const ownerJT = this.props.ownerDetails[this.state.selectedOwnerIndex] as OwnerJointTenant;
                return (
                    <div className="owner-detail-card">
                        <div>
                            <div className="owner-detail-card-name"> {ownerJT.name} </div>
                            {slAddress && (
                                <>
                                    <div className="owner-detail-card-address"> NA </div>
                                    <div className="owner-detail-card-address"> NA </div>
                                </>
                            )}
                        </div>
                        {/* <div>
                            <Button
                                text="CHANGE OWNER INFO"
                                size="small"
                                onClick={() => this.props.turnPage(AddOwnershipPages.OwnerDeviationsPage)}
                            />
                        </div> */}
                    </div>
                );

            default:
                return (
                    <div>
                        <span>Owner Type did not have a match</span>
                    </div>
                );
        }
    };

    submitOwnership = (values: AnyObject) => {
        console.log('Submit Ownership:', values);
    };

    render() {
        return (
            <Form
                onFormCreated={(form) => (this.form = form)}
                onSubmit={this.props.submitOwnership}
                hasFieldArray={true}
                keepDirty={true}
                initialValues={{
                    horizonId: PropertyUtil.SafeGet(() => this.props.tract.horizons[this.props.horizon].id),
                    parentOwnershipId: this.props.parentOwnershipId,
                    owners: this.props.searchResults?.items ? this.props.searchResults?.items : new Array<SearchResult>(),
                }}
                validate={this.props.validate}
            >
                <div>
                    {this.props.page === AddOwnershipPages.AddOwnershipLandingPage && (
                        <div style={{ height: '50rem' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
                                <div style={{ width: '50%', height: '100%', display: 'flex' }}>
                                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                                        <FormTextBox
                                            name="searchText"
                                            label="Search for Existing Owner"
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                this.searchUpdate(e.target.value, this.state.searchOwnerType === undefined ? 'All' : this.state.searchOwnerType)
                                            }
                                        />
                                        <div onScroll={(event) => this.props?.getScrollStatus(event.currentTarget)} className="owner-search-results">
                                            <div className="dialog-card-list">
                                                <span className="lh-tenth-width" />
                                                <span className="lh-fourth-width">ID</span>
                                                <span className="lh-fourth-width">Name</span>
                                                <span className="lh-fourth-width">Type</span>
                                            </div>
                                            {this.resultsList()}
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1rem' }}>
                                            <div>
                                                <Button
                                                    text="Create New Owner"
                                                    onClick={() => this.props.turnPage(AddOwnershipPages.NewOwnerInfoForm)}
                                                />
                                            </div>
                                            {(this.form?.getState().values as AnyObject)?.owners?.some((x: SearchResult) => x && x.selected) && (
                                                <div>
                                                    <Button text="Attach Owner" className="ml-1" onClick={this.attachOwner} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: '50%', display: 'flex' }}>
                                    <div className="owner-tracts-container">
                                        {this.props?.searchResults?.items && this.props.ownerTracts && <div className="owner-tract-header">Tracts</div>}
                                        <OwnerTracts
                                            tracts={this.props.ownerTracts}
                                            clientNumber={this.props.clientNumber}
                                            projectNumber={this.props.projectNumber}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div>
                    {this.props.page === AddOwnershipPages.OwnerDeviationsPage && !!this.props.ownerDetails && (
                        <>
                            {this.ownerDeviations()}
                            <div className="button-row">
                                <Button text="Previous" onClick={() => this.props.turnPage(AddOwnershipPages.DeviationDecimalInterest)} />
                                <Button text="CREATE NEW" size="medium" onClick={this.onClickCreateNewDeviation} />
                            </div>
                        </>
                    )}
                </div>
                <div>
                    {this.props.page === AddOwnershipPages.NewDeviationInfoForm && (
                        <>
                            {this.addNewDeviationHeader()}
                            <OwnerTypesForms
                                form={this.form}
                                getCityState={this.props.getCityState}
                                next={this.validateAttachOwnerPopupAndNextPage}
                                prev={() => this.props.turnPage(AddOwnershipPages.OwnerDeviationsPage)}
                                phoneNumberTypes={this.props.phoneNumberTypes}
                                selectedOwnerType={this.state.selectedOwnerType}
                                states={this.props.states}
                            />
                        </>
                    )}
                </div>
                <div>
                    {this.props.page === AddOwnershipPages.DeviationDecimalInterest && (
                        <>
                            {this.selectedOwnerInfo()}

                            {/* <FormSelect
                                        name={`${this.ownershipPref}.ownershipType`}
                                        label="Ownership Type"
                                        defaultOption={'FEE'}
                                        items={[new SelectItem(0, 'FEE')]}
                                        className="lh-half-width"
                                    /> */}
                            <div>
                                <div style={{ width: '300px'}}>
                                    <FormTextBox
                                        name={`${this.ownershipPref}.decimalInterest`}
                                        label="Decimal Interest"
                                        className="lh-half-width"
                                        isRequired={true}
                                    />
                                </div>
                                <div style={{ width: '400px', display: (this.state.selectedOwnerType !== OwnerType.Individual ? 'none' : 'inline-block') }}>
                                    <FormLabel text="Sole and Separate Property (SSP)?" />
                                    <div style={{ width: '100px'}}>
                                        <FormToggle onChange={this.onChangeCommunityPropertyToggle} name={`${this.ownershipPref}.isCommunityProperty`} items={['Yes', 'No']} />
                                    </div>
                                </div>
                                {this.props.parentOwnershipId > 0 && this.props.dialogType === 'ADD_ADDITIONAL_OWNERSHIP' && (
                                    <FormSelect
                                        name={`${this.ownershipPref}.additionalOwnershipTypeId`}
                                        label="Additional Ownership Type"
                                        items={[
                                            new SelectItem(1, 'HEIR'),
                                            new SelectItem(2, 'REMAINDERMAN'),
                                            new SelectItem(3, 'NON-EXECUTIVE'),
                                            new SelectItem(4, 'NON-PARTICIPATING'),
                                            new SelectItem(5, 'TRANSFER ON DEATH'),
                                            new SelectItem(6, 'NAKED OWNER'),
                                        ]}
                                        className="lh-half-width"
                                        isRequired={true}
                                    />
                                )}
                            </div>

                            <div>
                                <Button text="Prev" onClick={() => this.props.turnPage(AddOwnershipPages.AddOwnershipLandingPage)} />
                                <Button
                                    type="submit"
                                    text="Add Ownership"
                                    intent="primary"
                                    onClick={() => this.validateAttachOwnerPopupAndNextPage()}
                                />
                            </div>
                        </>
                    )}
                </div>
            </Form>
        );
    }
}

export default ExistingOwnerForm;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ExistingOwnerForm.tsx